import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_EVALUATION_METHOD,
  FORCE_DELETE_EVALUATION_METHOD,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addEvaluationMethod",
    method: "post",
    url: CRUD_EVALUATION_METHOD,
    stateKey: "message",
  },
  {
    name: "updateEvaluationMethod",
    method: "put",
    url: CRUD_EVALUATION_METHOD,
    stateKey: "message",
  },
  {
    name: "forceDeleteEvaluationMethod",
    method: "delete",
    url: FORCE_DELETE_EVALUATION_METHOD,
    stateKey: "message",
  },

  {
    name: "getEvaluationMethod",
    method: "get",
    url: CRUD_EVALUATION_METHOD,
    stateKey: "data",
  },
  {
    name: "getEvaluationMethodByAssessmentType",
    method: "get",
    url: CRUD_EVALUATION_METHOD,
    stateKey: "data",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
    evaluationMethodSelectedData: null,
  },
  reducers: {
    evaluationMethodSelect: (state, action) => {
      state.evaluationMethodSelectedData = action?.payload;
    },
  },
  // extraReducers: {
  //   // Example of custom extra reducer
  //   someCustomAction: (state, action) => {
  //     // Custom reducer logic
  //   },
  // },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "evaluationMethod",
  apiConfig,
  customReducers
);
const evaluationMethodSlice = slice;
// Export the slice's reducer
export default evaluationMethodSlice.reducer;

// Dynamically export all actions
export const actionsExports = actions;

// Destructure and export thunks directly from thunksExports
export const {
  addEvaluationMethod,
  updateEvaluationMethod,
  forceDeleteEvaluationMethod,
  getEvaluationMethod,
  getEvaluationMethodByAssessmentType,
} = thunks;

// Destructure and export actions directly from actionsExports
export const {
  evaluationMethodSelect,
} = actionsExports;
